document.addEventListener('DOMContentLoaded', function() {
      const imageWrapper = document.querySelector('.image-wrapper');

      if (imageWrapper) {
        // Adjust this value between 0.1 (slower) and 0.9 (faster)
        const parallaxSpeed = 0.4;

        window.addEventListener('scroll', function() {
          // Use requestAnimationFrame for smoother performance
          window.requestAnimationFrame(function() {
            let scrollPosition = window.scrollY;
            // Apply a vertical transform based on the scroll position and speed
            imageWrapper.style.transform = 'translateY(' + scrollPosition * parallaxSpeed + 'px)';
          });
        });
      }
    });